import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.einlasskontrolle-constants';
import * as api from '../../../clients/einlasskontrolle';

@Injectable()
export class EinlasskontrolleEinlasskontrolleConstantsEffects {

    EinlasskontrolleConstants$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_EINLASSKONTROLLE_CONSTANTS),
        mergeMap((x: ac.GetEinlasskontrolleConstantsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getEinlasskontrolleConstants().pipe(
                map((result: any) => {
                    return new ac.GetEinlasskontrolleConstantsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetEinlasskontrolleConstantsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.EinlasskontrolleTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.EinlasskontrolleTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.EinlasskontrolleTemplatesService);
        }
        return this.service;
    }
}
